/* This file is generated by bin/make_script_map.sh */
export const scriptMap: { [key: string]: string } = {
"Adlm": "Adlam",
"Aghb": "Caucasian_Albanian",
"Ahom": "Ahom",
"Arab": "Arabic",
"Armi": "Imperial_Aramaic",
"Armn": "Armenian",
"Avst": "Avestan",
"Bali": "Balinese",
"Bamu": "Bamum",
"Bass": "Bassa_Vah",
"Batk": "Batak",
"Beng": "Bengali",
"Berf": "Beria_Erfe",
"Bhks": "Bhaiksuki",
"Bopo": "Bopomofo",
"Brah": "Brahmi",
"Brai": "Braille",
"Bugi": "Buginese",
"Buhd": "Buhid",
"Cakm": "Chakma",
"Cans": "Canadian_Aboriginal",
"Cari": "Carian",
"Cham": "Cham",
"Cher": "Cherokee",
"Chrs": "Chorasmian",
"Copt": "Coptic",
"Cpmn": "Cypro_Minoan",
"Cprt": "Cypriot",
"Cyrl": "Cyrillic",
"Deva": "Devanagari",
"Diak": "Dives_Akuru",
"Dogr": "Dogra",
"Dsrt": "Deseret",
"Dupl": "Duployan",
"Egyp": "Egyptian_Hieroglyphs",
"Elba": "Elbasan",
"Elym": "Elymaic",
"Ethi": "Ethiopic",
"Gara": "Garay",
"Geor": "Georgian",
"Glag": "Glagolitic",
"Gong": "Gunjala_Gondi",
"Gonm": "Masaram_Gondi",
"Goth": "Gothic",
"Gran": "Grantha",
"Grek": "Greek",
"Gujr": "Gujarati",
"Gukh": "Gurung_Khema",
"Guru": "Gurmukhi",
"Hang": "Hangul",
"Hani": "Han",
"Hano": "Hanunoo",
"Hatr": "Hatran",
"Hebr": "Hebrew",
"Hira": "Hiragana",
"Hluw": "Anatolian_Hieroglyphs",
"Hmng": "Pahawh_Hmong",
"Hmnp": "Nyiakeng_Puachue_Hmong",
"Hrkt": "Katakana_Or_Hiragana",
"Hung": "Old_Hungarian",
"Ital": "Old_Italic",
"Java": "Javanese",
"Kali": "Kayah_Li",
"Kana": "Katakana",
"Kawi": "Kawi",
"Khar": "Kharoshthi",
"Khmr": "Khmer",
"Khoj": "Khojki",
"Kits": "Khitan_Small_Script",
"Knda": "Kannada",
"Krai": "Kirat_Rai",
"Kthi": "Kaithi",
"Lana": "Tai_Tham",
"Laoo": "Lao",
"Latn": "Latin",
"Lepc": "Lepcha",
"Limb": "Limbu",
"Lina": "Linear_A",
"Linb": "Linear_B",
"Lisu": "Lisu",
"Lyci": "Lycian",
"Lydi": "Lydian",
"Mahj": "Mahajani",
"Maka": "Makasar",
"Mand": "Mandaic",
"Mani": "Manichaean",
"Marc": "Marchen",
"Medf": "Medefaidrin",
"Mend": "Mende_Kikakui",
"Merc": "Meroitic_Cursive",
"Mero": "Meroitic_Hieroglyphs",
"Mlym": "Malayalam",
"Modi": "Modi",
"Mong": "Mongolian",
"Mroo": "Mro",
"Mtei": "Meetei_Mayek",
"Mult": "Multani",
"Mymr": "Myanmar",
"Nagm": "Nag_Mundari",
"Nand": "Nandinagari",
"Narb": "Old_North_Arabian",
"Nbat": "Nabataean",
"Newa": "Newa",
"Nkoo": "Nko",
"Nshu": "Nushu",
"Ogam": "Ogham",
"Olck": "Ol_Chiki",
"Onao": "Ol_Onal",
"Orkh": "Old_Turkic",
"Orya": "Oriya",
"Osge": "Osage",
"Osma": "Osmanya",
"Ougr": "Old_Uyghur",
"Palm": "Palmyrene",
"Pauc": "Pau_Cin_Hau",
"Perm": "Old_Permic",
"Phag": "Phags_Pa",
"Phli": "Inscriptional_Pahlavi",
"Phlp": "Psalter_Pahlavi",
"Phnx": "Phoenician",
"Plrd": "Miao",
"Prti": "Inscriptional_Parthian",
"Rjng": "Rejang",
"Rohg": "Hanifi_Rohingya",
"Runr": "Runic",
"Samr": "Samaritan",
"Sarb": "Old_South_Arabian",
"Saur": "Saurashtra",
"Sgnw": "SignWriting",
"Shaw": "Shavian",
"Shrd": "Sharada",
"Sidd": "Siddham",
"Sidt": "Sidetic",
"Sind": "Khudawadi",
"Sinh": "Sinhala",
"Sogd": "Sogdian",
"Sogo": "Old_Sogdian",
"Sora": "Sora_Sompeng",
"Soyo": "Soyombo",
"Sund": "Sundanese",
"Sunu": "Sunuwar",
"Sylo": "Syloti_Nagri",
"Syrc": "Syriac",
"Tagb": "Tagbanwa",
"Takr": "Takri",
"Tale": "Tai_Le",
"Talu": "New_Tai_Lue",
"Taml": "Tamil",
"Tang": "Tangut",
"Tavt": "Tai_Viet",
"Tayo": "Tai_Yo",
"Telu": "Telugu",
"Tfng": "Tifinagh",
"Tglg": "Tagalog",
"Thaa": "Thaana",
"Thai": "Thai",
"Tibt": "Tibetan",
"Tirh": "Tirhuta",
"Tnsa": "Tangsa",
"Todr": "Todhri",
"Tols": "Tolong_Siki",
"Toto": "Toto",
"Tutg": "Tulu_Tigalari",
"Ugar": "Ugaritic",
"Vaii": "Vai",
"Vith": "Vithkuqi",
"Wara": "Warang_Citi",
"Wcho": "Wancho",
"Xpeo": "Old_Persian",
"Xsux": "Cuneiform",
"Yezi": "Yezidi",
"Yiii": "Yi",
"Zanb": "Zanabazar_Square",
"Zinh": "Inherited",
"Zyyy": "Common",
"Zzzz": "Unknown",
};
